// extracted by mini-css-extract-plugin
module.exports = {"copyrights":"Copyrights_copyrights__sPgDJ","list":"Copyrights_list__SzBnh"};